import { CSSObject } from '@chakra-ui/react';

export const BadgeCountdown = (
  state: 'inprogress' | 'prior' | 'ended'
): CSSObject => ({
  '&&&&': {
    bg: () => {
      if (state === 'inprogress') {
        return 'blackAlpha.600';
      }
      if (state === 'ended') {
        return 'red.500';
      }
      // 'prior'
      return 'alpha.600';
    },
    color: () => {
      if (state === 'inprogress') {
        return 'alpha.400';
      }
      if (state === 'ended') {
        return 'white';
      }
      // 'prior'
      return 'alpha.900';
    },
    borderRadius: 'sm',
    px: 1,
    fontFamily: 'roboto',
    fontWeight: 'bold',
  },
  '&&': {
    h: '16px',
    maxH: '16px',
    minH: '16px',
    lineHeight: '16px',
  },
});
